import { useEffect, useState } from 'react'
import { cn, Modal, Text, PrimaryButton, Alert } from '@artprov/design-system'
import { InputMonthYear } from '../../common/components/InputMonthYear/InputMonthYear'

export default function ModalPeriodo({
  openModal,
  onCloseModal,
  mensaje = 'Mensaje en el inputTextArea',
  subtitulo = 'subtitulo',
  titulo = 'Titulo del modal',
  hintsInputMonth = [{}],
  onAcceptModal,
  disabledBtnAceptar = true,
  onRedirectToCargarNomina,
  showAlertRectificativa = false,
}) {
  const [isValidPeriodo, setIsValidPeriodo] = useState(false)
  const [periodo, setPeriodo] = useState('')
  const [localHints, setLocalHints] = useState([])

  // Sync hints from parent prop (e.g. after API validation failure)
  useEffect(() => {
    setLocalHints(hintsInputMonth)
  }, [hintsInputMonth])

  // Reset state when the modal opens
  useEffect(() => {
    if (openModal) {
      setPeriodo('')
      setIsValidPeriodo(false)
      setLocalHints([])
    }
  }, [openModal])

  const handleOnAcceptModal = async () => {
    // Si el período ya fue cargado (rectificativa), redirigir directamente sin revalidar
    if (showAlertRectificativa) {
      onCloseModal()
      onRedirectToCargarNomina(periodo)
      return
    }
    const response = await onAcceptModal(periodo)
    if (response) {
      onCloseModal()
      onRedirectToCargarNomina(periodo)
    }
  }

  const handleOnChangePeriodo = (value) => {
    setPeriodo(value)
    // Clear error hints from the parent when the user modifies the input
    setLocalHints([])
  }

  return (
    <Modal.Container
      open={openModal}
      className={cn('overflow-x-hidden')}
      onClose={onCloseModal}
      closeOnClickOutside={false}
    >
      {/* <Modal.Content width={650} height={260}> */}
      <Modal.Content width={713} height={'auto'} className={cn('overflow-x-hidden')}>
        <Modal.Header>
          <Modal.Title className="pl-2">{titulo}</Modal.Title>
          <Modal.Close onClose={() => onCloseModal()} />
        </Modal.Header>
        <Modal.Body className="pl-1 -mt-3">
          {showAlertRectificativa && (
            <Alert
              variant="warning"
              title=""
              description="Este período ya fue cargado. Si aceptás, se generará una rectificativa"
              icon="info"
              iconStyle="text-warning-10"
              autoDismiss={false}
              interactive={false}
              containerStyle="w-[645px] mb-4"
            />
          )}
          <Text variant="body2" className="text-tertiary-20 mb-2">
            Indicá a que período corresponde la nómina
            <span className="text-error-20 ml-1">*</span>
          </Text>
          <InputMonthYear
            // classNameContainerInput={'flex justify-end w-[580px]'}
            classNameContainerInput={'flex justify-end w-[645px]'}
            className={cn('overflow-x-hidden')}
            hints={localHints}
            minYear={2006}
            onChange={handleOnChangePeriodo}
            onValidate={(isValid) => setIsValidPeriodo(isValid)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Modal.CancelButton onClick={() => onCloseModal()}>Cancelar</Modal.CancelButton>
          <PrimaryButton
            className="mx-3"
            size="small"
            onClick={handleOnAcceptModal}
            classNameIcon="text-tertiary-100"
            disabled={!isValidPeriodo && !showAlertRectificativa}
          >
            Aceptar
          </PrimaryButton>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Container>
  )
}
